const subtleCrypto = window?.crypto?.subtle;

export const PUBLIC_KEY =
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAw20gxgGD4w/Q00gycLdh' +
  'J20gIsBM1DCm4lwvfZW98mBLXSzCsufPdPg/4TdIFsXYjMEdlFlWoc1ur08T/LgF' +
  'wU6bPJ+9QisBbpGnNo/NG12EjWYZWWvKl0+XXB9G337kQQKlNnytEgX0bFNFziMZ' +
  'f+Aun0rHU3FK1rbs+TTuEScFPa6hUoiYUTZS0cVe9uwl7nuVoZt2WmND6nRMR2aB' +
  'c0STfG/oUae0dhiECbk+kCpZS9cLkDCc9lSEOlvZmhZkKqnlJ1+I0j23H1A/0nXe' +
  'Y6H59Tix0WVHQ5g/4zwzzTDwuwHBwpf9b4/wwDhU20uohXkShsnj5YI5w01H38SR' +
  'CwIDAQAB';

export const ALGORITHM: RsaHashedImportParams = {
  name: 'RSA-OAEP',
  hash: { name: 'SHA-256' },
};

export async function encrypt(data: string, publicKey: string, algorithm: RsaHashedImportParams) {
  const key = await generatePublicKey(publicKey, algorithm);
  const encrypted = await encryptData(data, key, algorithm);
  return btoa(ab2str(encrypted));
}

async function encryptData(data: string, key: CryptoKey, algorithm: RsaHashedImportParams) {
  const dataBuffer = str2ab(data);
  return await subtleCrypto?.encrypt(algorithm, key, dataBuffer);
}

async function generatePublicKey(publicKey: string, algorithm: RsaHashedImportParams) {
  const publicKeyBuff = str2ab(atob(publicKey));
  return await subtleCrypto?.importKey('spki', publicKeyBuff, algorithm, false, ['encrypt']);
}

// String to arraybuffer
function str2ab(data: string) {
  const buf = new ArrayBuffer(data.length);
  const bufView = new Uint8Array(buf);

  for (let i = 0, strLen = data.length; i < strLen; i++) {
    bufView[i] = data.charCodeAt(i);
  }
  return buf;
}

// ArrayBuffer to string
function ab2str(buffer: ArrayBuffer) {
  return String.fromCharCode(...Array.from(new Uint8Array(buffer)));
}
